import { academiesLocaleEs } from '../sections/Academies/i18n';
import { bundlesLocaleEs } from '../sections/Bundles/i18n';
import { careersLocaleEs } from '../sections/Careers/i18n';
import { coursesLocaleEs } from '../sections/Courses/i18n';
import { degreesLocaleEs } from '../sections/Degrees/i18n';
import { tracksLocaleEs } from '../sections/Tracks/i18n';

const localeEs = {
  es: {
    ...academiesLocaleEs,
    ...bundlesLocaleEs,
    ...careersLocaleEs,
    ...coursesLocaleEs,
    ...degreesLocaleEs,
    ...tracksLocaleEs,
  },
};
export default localeEs;
